module.exports = __webpack_public_path__ + "static/media/eleventh_city_hall.8edd901a.mp4";